import { lazyLoad } from "utils/loadable"

export const HubDashboardPage = lazyLoad(
  () => import("./index"),
  module => module.HubDashboardPage,
)
